import { render, staticRenderFns } from "./Entrepreneurship.vue?vue&type=template&id=8444a8a2&"
import script from "./Entrepreneurship.vue?vue&type=script&lang=js&"
export * from "./Entrepreneurship.vue?vue&type=script&lang=js&"
import style0 from "./Entrepreneurship.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports